import React from 'react';
import style from './style.scss';
import Product from 'components/partials/product';
import {Categories} from 'api';
import {connect} from 'react-redux';
import {asyncConnect} from 'redux-connect';

@asyncConnect([
  {
    key: 'products',
    promise: ({match: {
        params
      }, helpers}) => {
      const _params = {
        id: this.props.categoryId,
        filter: {
          limit: 4,
          // where: {
          //   id: {
          //     neq: this.props.productId
          //   }
          // }
        }
      }

      return Categories.actions.listProducts.request(_params).then(response => {
        return Promise.resolve(response.data);
        // if (response && response.data) {
        //   this.setState({data: response.data});
        // }
      }).catch((error) => {
        console.log(error)
      });
    }
  }
])
class ListProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.categoryId) {
      const params = {
        id: this.props.categoryId,
        filter: {
          limit: 4,
          where: {
            id: {
              neq: this.props.productId
            }
          }
        }
      };
      Categories.actions.listProducts.request(params).then(response => {
        if (response && response.data) {
          this.setState({data: response.data});
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categoryId) {
      const params = {
        id: nextProps.categoryId,
        filter: {
          limit: 4,
          where: {
            id: {
              neq: nextProps.productId
            }
          }
        }
      };
      Categories.actions.listProducts.request(params).then(response => {
        if (response && response.data) {
          this.setState({data: response.data});
        }
      });
    }
  }

  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    return (
      <section className="list-product">
        <h2 className='title-bottom-content'>Các sản phẩm tương tự</h2>
        {this.state.data.map((item, i) => {
          return (
            <div className='product-wrap' key={i}>
              <Product enableAddProduct={true} {...item}/>
            </div>
          );
        })
}
      </section>
    );
  }
}

export default connect()(ListProduct);



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product/ListProduct.jsx